import { FlaggedQuestionsList } from "./FlaggedQuestionsList";

export default {
    list: FlaggedQuestionsList
};